import { Feature } from '@tencent/workbench';
import BaseToolbarFeature from '@src/framework/workbench/common/feature/base-toolbar-feature';
import type { IJumpToPrevCommentFeature } from './jump-to-prev-comment-interface';
import { config } from './config';
import { CommentShowAction } from '@src/js/constant';

@Feature()
export class JumpToPrevCommentFeature extends BaseToolbarFeature implements IJumpToPrevCommentFeature {
    public id = config.id;
    public config = config;
    public constructor() {
        super();
    }

    public handleJumpToPrevComment(): void {
        this.getAppService().viewableServiceLayer.commentManager.promise().then((commentManager) => {
            commentManager.setCommentShowAction(CommentShowAction.PREV_COMMENT_GROUP);
        });
    }

    protected getCustomDisabledState() {
        const count = this.getCommentManager().dangerousInstance?.getCommentCount();
        return !count;
    }

    private getCommentManager = () => this.getAppService().viewableServiceLayer.commentManager;
}
